<div>
    <div>
        <app-collapse-button [isActive]="!isEditable" (click)='collapse()'></app-collapse-button>
        <app-reload-button-sm [isActive]="!isEditable && !isLoading" [isLoading]="isLoading" (click)="reload()"></app-reload-button-sm>
        <!-- <app-add-button-sm [isActive]="!isEditable && !isLoading" (click)='add()'></app-add-button-sm> -->
        <div (click)='collapse()' class='group-title' style='cursor: pointer;'>
            Registrations
            <div *ngIf="!isLoading" class='results'>({{courseRegistrations.length}})</div>
        </div>
    </div>
</div>

<!-- <div [ngClass]="{'hide':!display}"> -->
<div>

    <app-loading [isLoading]="isLoading" *ngIf="isLoading"></app-loading>

    <div *ngIf="!isLoading">
        <div *ngIf='isAdd'>
            <div class='index'>
                <div class='row title' style='display:none;'></div>
                <div>
                    <app-course-registration></app-course-registration>
                </div>
            </div>
        </div>

        <div [ngClass]="{hide: isAdd}">
            <div class='text-center alert-text' *ngIf="errorMessage">
                {{errorMessage}}
            </div>

            <div *ngIf="!errorMessage">
                <div class='instructions' *ngIf='courseRegistrations.length === 0'>
                    No Registrations are associated with this Course.
                </div>

                <div class='instructions' *ngIf='courseRegistrations.length > 0'>
                    Listed below are the Registrations associated with this Course.
                </div>

                <div class='index'>

                    <div class='row title'>
                        <div class='col-sm-1'>ID</div>
                        <div class='col-sm-8'>Name</div>
                        <div class='col-sm-1 text-center'>Status</div>
                        <div class='col-sm-1'></div>
                    </div>

                    <div class='row' *ngIf='courseRegistrations.length === 0'>
                        <div class='col-sm-12 text-center'>
                            There are no Registrations to report for this Course.
                        </div>
                    </div>

                    <div *ngFor="let courseRegistration of courseRegistrations" class='row'>
                        <app-course-registration [courseRegistration]="courseRegistration" style="width:100%;"></app-course-registration>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>